export default __webpack_public_path__ + "4ca032022224a96e6e7ae7465136fce5.svg";